import { AvailabilityRefreshTimer } from './availability-refresh-timing-types';

export function createAvailabilityRefreshTimer(
  now: () => number = Date.now
): AvailabilityRefreshTimer {
  const staleSince = new Map<string, number>();
  return {
    markStale: (configId) => {
      if (!staleSince.has(configId)) staleSince.set(configId, now());
    },
    settle: (configId) => {
      const since = staleSince.get(configId);
      if (since === undefined) return null;
      staleSince.delete(configId);
      return now() - since;
    }
  };
}

export function logAvailabilityRefresh(
  configId: string,
  elapsedMs: number | null
): void {
  if (elapsedMs === null || process.env.NODE_ENV !== 'development') return;
  console.log(
    `[valid-systems-watcher] availability for config ${configId} refreshed ${elapsedMs}ms after going stale`
  );
}
